import { IEntity, ITypeEntityFragment } from '@pf/shared-common';
import {
    ContainerSearchRequestParams,
    ContainerStatus,
    ContainerViewModelCreateBody,
    ContainerViewModelRead,
    EquipmentFragment,
    InventoryBundleFragment,
    ResourceAuth,
    SlotFragment,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import {
    ICustomFieldDto,
    ILocationFragmentDto,
} from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { StatusOptions } from '@pf/shared-ui';

export type ContainerRead = ContainerViewModelRead &
    IEntity & {
        containerType: ITypeEntityFragment;
    };
export type ContainerCreate = ContainerViewModelCreateBody;
export type ContainerSearchParams = ContainerSearchRequestParams & {
    warehouseId?: string;
};

export class ContainerDto implements IWarehouseEntity {
    constructor(data: Partial<ContainerDto>) {
        Object.assign(this, data);
        this.status = this.status || ContainerStatus.Unassigned;
    }

    id!: string;
    warehouse!: WarehouseFragment;

    equipment?: EquipmentFragment;
    parentContainerId?: string | null;
    rootContainerId?: string | null;
    palletPositions?: number;
    resourceAuth?: ResourceAuth;
    lpn?: string | null;
    createdDate?: string;
    modifiedDate?: string;
    status?: ContainerStatus;
    isDeleted?: boolean;
    slot?: SlotFragment;
    containerType?: ITypeEntityFragment;
    reservedForLocation?: ILocationFragmentDto;
    customFields?: Array<ICustomFieldDto> | null;
    inventoryBundles?: Array<InventoryBundleFragment> | null;
    children?: ContainerDto[];
}

export const ContainerStatusOptions: StatusOptions = {
    [ContainerStatus.Empty]: {
        label: 'Empty',
        color: '#4B89DA', // Blue
    },
    [ContainerStatus.Loaded]: {
        label: 'Loaded',
        color: '#5CB85C', // Green
    },
    [ContainerStatus.Unassigned]: {
        label: 'Unassigned',
        color: '#5faff3', // Light Blue
    },
    [ContainerStatus.Putaway]: {
        label: 'Putaway',
        color: '#337AB7', // Darker Blue
    },
    [ContainerStatus.Picked]: {
        label: 'Picked',
        color: '#8BC34A', // Light Green
    },
    [ContainerStatus.Packed]: {
        label: 'Packed',
        color: '#4CAF50', // Darker Green
    },
    [ContainerStatus.Shipped]: {
        label: 'Shipped',
        color: '#777777', // Dark Grey
    },
    [ContainerStatus.Archived]: {
        label: 'Archived',
        color: '#9E9E9E', // Grey
    },
    [ContainerStatus.OutOfOrder]: {
        label: 'Out of Order',
        color: '#D9534F', // Red
    },
    defaultOption: {
        label: 'Unknown',
        color: '#808080', // Standard Grey
    },
};
